<script>
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ButtonIcon from "@/components/molecules/button-icon";

export default {
  name: "MonCompte",
  components: { List, ListItem, ButtonIcon },
  props: {
    firstName: {
      type: String,
      default: ""
    },
    isPro: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["logout"],
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$emit("logout");
    }
  }
};
</script>

<template>
  <div class="c-header-mon-compte">
    <List class="c-header-mon-compte__list">
      <ListItem class="c-header-mon-compte__list-item c-header-mon-compte__list-item--hello">
        Bonjour {{ firstName }}
      </ListItem>
      <ListItem class="c-header-mon-compte__list-item">
        <ButtonIcon
          icon-name="user-outline"
          size="md"
          class="c-header-mon-compte__button"
          to="/mon-compte"
        >
          <span class="u-font-12">Mon compte</span>
        </ButtonIcon>
      </ListItem>
      <ListItem class="c-header-mon-compte__list-item">
        <ButtonIcon
          icon-name="command"
          size="md"
          class="c-header-mon-compte__button"
          to="/mon-compte/mes-commandes"
        >
          <span class="u-font-12">Mes achats</span>
        </ButtonIcon>
      </ListItem>
      <ListItem
        v-if="!isPro"
        class="c-header-mon-compte__list-item"
      >
        <ButtonIcon
          icon-name="fidelity"
          size="md"
          class="c-header-mon-compte__button"
          to="/mon-compte/ma-fidelite"
        >
          <span class="u-font-12">Mon espace fidélité</span>
        </ButtonIcon>
      </ListItem>
      <ListItem
        v-if="!isPro"
        class="c-header-mon-compte__list-item"
      >
        <ButtonIcon
          icon-name="my-subscribe"
          size="md"
          to="/mon-compte/abonnements"
          class="c-header-mon-compte__button"
        >
          <span class="u-font-12">Mes abonnements</span>
        </ButtonIcon>
      </ListItem>
      <ListItem class="c-header-mon-compte__list-item">
        <ButtonIcon
          icon-name="cross-thin"
          size="md"
          icon-color="text-light"
          class="c-header-mon-compte__button "
          @click="logout"
        >
          <span class="u-color-text-light u-font-12">Me déconnecter</span>
        </ButtonIcon>
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-mon-compte.scss";
</style>
